<template>

  <div :class="{'uk-card':true, 'uk-card-default':true, 'uk-card-primary':odd, 'uk-card-secondary': !odd, 'uk-card-hover': true}">

    <div class="uk-card-header">
      <div class="uk-card-title">{{data.names.title}}</div>
      <h6>Showing Data from {{from_date}} to {{thru_date}}.</h6>
    </div>

    <div class="uk-card-body">
      <div class="card-stretch-container">
        <div class="bignumber secondary">
          <div class='number'>
            {{data.rate}}%
          </div>
          <div class='label'>
            {{data.names.rate}}
          </div>
        </div>
        <div class="bignumber">
          <div class='number'>
            {{numerator}}
          </div>
          <div class='label'>
            {{data.names.numerator}}
          </div>
        </div>
        <div class="bignumber">
          <div class='number'>
            {{denominator}}
          </div>
          <div class='label'>
            {{data.names.denominator}}
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
	export default {
		name: "genericPercentageCard",
        props: ["data", "odd", "thru_date", "from_date"],
        computed: {
		    numerator: function() {
		        return this.data.numerator.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            denominator: function() {
		        return this.data.denominator.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        }
	}
</script>

<style lang="less" scoped>


  @import "../../assets/less/palette.less";
  @import "../../assets/less/theme.less";


  .card-stretch-container {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }


  h6 {
    margin-top: 5px;
  }

  .bignumber {

    color: white!important;

    .number {
      font-size: 60px;
    }

    .label {
      font-size: 12px;
    }
  }


  @media only screen and (max-width: @breakpoint-medium) {
      .card-stretch-container {
        flex-direction: column;
        justify-content: center;

        .bignumber {
           margin: 10px 0;
        }
      }
  }

</style>
